import { gql } from 'urql';

const QueryChargeCardApplicationStatuses = gql`
  query ChargeCardApplicationStatuses {
    applications {
      __typename
      ... on ChargeCardApplication {
        id
        chargeCardApplicationStatus
      }
    }
  }
`;

export default QueryChargeCardApplicationStatuses;
